<template>
    <div class="locale-font">
        <div class="header mt-5">
            {{ $vuetify.lang.t('$vuetify.blacklist.blacklist')}}
        </div>

        <nav-bar
            ref="navbar"
            @menu-change="menuChange"
            :menuItem="navbarList" />

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import BlacklistLists from '@/components/Blacklist/BlacklistLists.vue'
import BlacklistActivity from '@/components/Blacklist/BlacklistActivity.vue'
export default {
    name: 'Blacklist',

    components: {
        NavBar,
        BlacklistLists,
        BlacklistActivity
    },

    data () {
        return {
            component: '',
            menuItem: [
                {
                    title: this.$vuetify.lang.t('$vuetify.blacklist.blacklistLists'),
                    path: 'BlacklistLists',
                    pathName: 'list',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.blacklist.blacklistActivity'),
                    path: 'BlacklistActivity',
                    pathName: 'activity',
                    permission: []
                }
            ],

            mappedTranslationNavbar: {
                BlacklistLists: 'blacklistLists',
                BlacklistActivity: 'blacklistActivity'
            }
        }
    },

    computed: {
        navbarList () {
            const navbar = []
            for (const item of this.menuItem) {
                navbar.push(item)
            }
            return navbar
        }
    },

    methods: {
        setLangNavBar () {
            for (let i = 0; i < this.menuItem.length; i++) {
                if (this.mappedTranslationNavbar[this.menuItem[i].path]) {
                    this.menuItem[i].title = this.$vuetify.lang.t(`$vuetify.blacklist.${this.mappedTranslationNavbar[this.menuItem[i].path]}`)
                }
            }
        },

        menuChange (payload) {
            this.component = payload.path

            const path = `/blacklist/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        setActive (path) {
            let index = 0
            if (path === 'Blacklist') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            this.component = this.navbarList[index].path
            const directPath = `/blacklist/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.setActive(this.$router.currentRoute.name)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangNavBar()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
